var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app agam-app"},[_c('div',{staticClass:"app-content"},[_c('div',{staticClass:"right"},[_c('AppHeader'),_c('main',{staticClass:"app-main",style:(_vm.$route.matched.find(c => c.name === 'AuthApp') ? 'margin-top: 0 !important' : '')},[_c('router-view',{staticClass:"main-content"})],1)],1)]),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }